<template>
    <v-main>
        <v-container v-if="loading">
            <cardWait />
        </v-container>
        <v-container fluid class="relative ma-2" v-if="!loading">
            <v-row cols="12">
                <v-col cols="12" class="pr-6">
                    <cardVirtualConversations :conversations="conversations" :assistants="assistants" @updateData="updateData"/>
                </v-col>
            </v-row>
            <v-row cols="12">
                <v-col cols="4" class="pr-6" v-for="conversation in conversations" :key="conversation.id">
                    <cardVirtualConversation :conversation="conversation" :assistants="assistants" @updateData="updateData"/>
                </v-col>
            </v-row>
        </v-container>
        <navbar title="ARES - OpenAI" type="openai" :home="true" @actionClick="actionClick" />
    </v-main>
</template>

<script>
    import navbar from '@/components/ui/navbars/navbar.vue';

    import cardWait from '@/components/syst/openai/cardWait.vue';
    import cardVirtualConversation from '@/components/syst/openai/cardVirtualConversation.vue';
    import cardVirtualConversations from '@/components/syst/openai/cardVirtualConversations.vue';

    export default {        
        components: {
            navbar,
            cardWait,
            cardVirtualConversation,
            cardVirtualConversations,
        },
        data() {
            return {
                loading: true,
                conversations: [],
                assistants: [],
            }
        },
        mounted() {
            this.getConversations(false);
        },
        methods: {
            getConversations(refresh) {
                this.loading = true;
                this.$axios.post("ares/json/ares/syst/openai/getConversations.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getConversations"
                    },
                    getConversations: {
                        refresh: refresh,
                    },
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.conversations = res.data.getConversations.conversations;
                        this.assistants = res.data.getConversations.assistants;
                        this.loading = false;
                    }
                });
            },
            // Dummy callback for navBar
            actionClick() {

            },           
            updateData(data) {
                switch (data) {
                    case "refresh":
                        this.getConversations(true);
                        break;
                    default:
                }
            },           
        },
    }
</script>

<style scoped>
</style>
